<script lang="ts">import { t, Verbiage } from "@infinitro/content";
import { getIcon } from "../data/icons";
const RefreshIcon = getIcon("RefreshIcon");
export let hover = false;
</script>

{#if typeof RefreshIcon === 'string'}
	<img src={RefreshIcon} alt={$t(Verbiage.icon_alt, 'alts')} />
{:else if typeof RefreshIcon === 'function'}
	<svelte:component this={RefreshIcon} {hover} />
{:else}
	<span>Invalid icon</span>
{/if}

<style>
</style>
